<template>
    <div class="row col-lg-12" style="padding-left: 0px;">
        <div class="col-lg-12 mb-3">
            <a v-b-toggle.company-fill-collapse class="collapse-link">Use Company Auto Fill </a>
        </div>
        <b-collapse :visible="visible" id="company-fill-collapse" class="col-lg-12 row">
            <div
            v-if="form"
            v-for="(companyField, index) in companyApiFields"
            :class="{
            'col-md-2': companyField.type == 'button',
            'col-md-6': companyField.type != 'button',
            }"
            >
    
                <b-button  v-if="companyField.type == 'button'"
                variant="primary"
                :class="{
                    'mr-3': true,
                    'disabled': loading
                }"
                           class="fetchBtn"
                :disabled="loading || ( companyField.allowedClick && !companyField.allowedClick())"
                @click="companyField.onClick">
                    <span v-if="!loading" style="opacity: 1;" class="btn-text" >{{ companyField.title }}</span>
                    <span v-else class="loader"></span>
                </b-button>
                <component v-else
                    :is="companyField.type"
                    :field="companyField"
                    :data-segment-id="dataSegmentId"
                ></component>
            </div>
            <div class="col-lg-12 mb-1 mt-3">
                <h5 class="text-muted">Or Enter Manually</h5>
            </div>
        </b-collapse>
    </div>

</template>

<script>
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'
import TextField from '@/components/registration/TextField.vue'
import axios from 'axios'
import _ from 'lodash'

const apiBaseUrl = process.env.VUE_APP_API_URL;


export default {
    /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
    components: {
        TextField,
    }, // End of Component > components

    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {
        fields: {
            type: Array
        },
        // checkAddressExists:{
        //     type: Boolean,
        //     default: false,
        // }
    }, // End of Component > props

    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            configData: [],
            showCompanyFeature: process.env.VUE_APP_AUTO_FILL_COMPANY == 'true',
            allowCompanyReset: false,
            visible:true,
            companyFields :[ 'basicInfo.firstName','basicInfo.dateOfBirth', 'identityInfo.number',
                                  'basicInfo.countryOfResidenceId','basicInfo.companyStatus',
                                  'basicInfo.companyType','contactInfo.address','contactInfo.city','contactInfo.postalCode','contactInfo.state'],
            companyApiFields: [
                {
                    _id: "company_no",
                    key: "company_no",
                    type: 'text-field',
                    label: "Company Number",
                    isRequired: false,
                    minLength: 1,
                    maxLength: 100,
                    placeholder: "Enter Company Number",
                },
                // {
                //     _id: "post_code",
                //     key: "post_code",
                //     type: 'text-field',
                //     label: "Post Code",
                //     isRequired: false,
                //     minLength: 1,
                //     maxLength: 100,
                //     placeholder: "Enter Post Code",
                // },
                {
                    _id: "submit_address",
                    type: 'button',
                    title: 'fetch',
                    allowedClick: ()=> true,//this.allowCompanyApiSubmit,
                    onClick: (e) => {
                        let CompanyNo = document.getElementById(`id_company_no`) ? document.getElementById(`id_company_no`).value : document.getElementById(`id_company_no`);
                        // let postCode = document.getElementById(`id_post_code`) ? document.getElementById(`id_post_code`).value : document.getElementById(`id_post_code`);
                        if(!CompanyNo){
                            this.$store.commit('setError', "Company Number is required")
                            return;
                        }
                        // else if( !parseInt(CompanyNo) ){
                        //     this.$store.commit('setError', "Company Number must be a valid number")
                        //     return;
                        // }
                        this.getCompanyDetail(CompanyNo)
                    }
                },
                {
                    _id: "reset_auto_company",
                    type: 'button',
                    title: 'Reset',
                    allowedClick: ()=> this.allowCompanyReset,
                    onClick: (e) => {
                       this.resetCompanyFields();
                    }
                },
            ], 
        }
    }, // End of Component > data

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapGetters(['loading', 'form', 'registration','getField']),
        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
        allowCompanyApiSubmit() {
            return this.form && this.form.customInfo && 
            (this.form.customInfo.company_no && this.form.customInfo.company_no.value)
        },
        companyFieldsIds(){
                       return  this.fields
                                        .filter((el)=> this.companyFields.includes(el.key))
                                        .map((el)=> `id_${el._id}`);
        },
        fieldsShouldGrayIds(){
                     return  this.fields
                                        .filter((el)=> this.companyFields.includes(el.key) && this.getField(el.key))         //filtering non-empty fields
                                        .map((el)=> `id_${el._id}`);
        },
        fieldsShouldNotGrayIds(){
                     return  this.fields
                                        .filter((el)=> this.companyFields.includes(el.key) && !this.getField(el.key))         //filtering non-empty fields
                                        .map((el)=> `id_${el._id}`);
        },
        route(){
          return this.$route.path
        }
    }, // End of Component > mounted

    /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */
    watch: {
        // fieldsShouldGrayIds(value){
        //    this.grayOutBackground(value)
        // },
        fieldsShouldNotGrayIds(value){
            this.grayOutBackground(value,true)
        }
    }, // End of Component > methods

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    created() {
        this.configData = this.$store.state.registration.configData
    },
    async mounted() {

        this.toggleComponent();
        
    }, // End of Component > computed
    async updated() {
        this.toggleComponent();
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        async resetCompanyFields() {
            for (let i = 0 ; i < this.companyFields.length ; i++){
                this.$store.commit('updateField', {
                                         key: this.companyFields[i],
                                         value: null,
                                     })
            }
            let arrayFields = ['dynamicInputValues.companyDirectors','dynamicInputValues.authorisedPersons']
            for(let i=0; i < arrayFields.length ; i++){
                if(this.getField(arrayFields[i]) && this.getField(arrayFields[i]).length > 0){
                            let valuesToCompare = this.getField(arrayFields[i]) 
                        
                            valuesToCompare = valuesToCompare.filter(obj => !('isCompanyAPI' in obj));                        
                            this.$store.commit('updateField', {
                                                    key: arrayFields[i],
                                                    value: valuesToCompare,
                                                })
                    }            
            }
            let companyHouseApiRiskoverrides = this.getField("companyHouseApiRiskoverrides")
            for (let key in companyHouseApiRiskoverrides){
                    this.$store.commit('updateField', {
                                            key: `companyHouseApiRiskoverrides.${key}`,
                                            value: null,
                                        })
            }          
            
            
            this.grayOutBackground(this.companyFieldsIds, true) // revert = true
            this.allowCompanyReset = false;

        },
        async getCompanyDetail(companyNumber)
        {
            try {
                this.$store.commit('setLoading', true)
                await this.resetCompanyFields()
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('vueauth_token')}`,
                    }
                }
                
                const postData = {
                    companyNumber,
                    dataSegmentId:this.dataSegmentId,
                    isAuthenticated:this.route.includes('deep-register') ? true : false
                }
                const {data} = await axios.post(apiBaseUrl + 'customers/company-detail', postData, config) 
               
                let errorAlias = {
                    'dynamicInputValues.companyDirectors': 'Company Directors',
                    'dynamicInputValues.authorisedPersons': 'Authorised Persons'
                }
                let errorString = ""

                let arrayFields = ['dynamicInputValues.companyDirectors','dynamicInputValues.authorisedPersons']
                for (let section in data.data){
                    if(arrayFields.includes(section)){
                        if(data.data[section].length > 0 ){
                                let previousData = this.getField(section)
                                if(previousData && previousData.length > 0){
                                       previousData = previousData.filter(obj => !('isCompanyAPI' in obj));                        
                                       data.data[section].push(...previousData)
                                }
                                this.$store.commit('updateField', {
                                                        key:   section,
                                                        value: data.data[section],
                                                    })
                                }
                        else{
                            errorString =  errorString + (errorAlias[section] == 'Authorised Persons' ? errorAlias[section] : errorAlias[section] +", ")
                            
                        }
                    }
                    else {
                        if(Object.keys(data.data[section]).length > 0 ){
                                for(let key in  data.data[section]){
                                       
                                        this.$store.commit('updateField', {
                                                            key:   key,
                                                            value: data.data[section][key],
                                        
                                    })
                                    }
                        }
                        else{
                                errorString =  errorString + section +", "
                        }
                }

               
             }
             if(errorString){
                    this.$store.commit('setError', `Could not able to fetch ${errorString} from company house API`)
                    errorString = ""
                }
               
                this.grayOutBackground(this.fieldsShouldGrayIds)
                                     
                this.$store.commit('setLoading', false)
                this.allowCompanyReset = true
                return true
            } catch(e) {
                console.log('resp error:', e);
                // this.handleGetCompanyFailure(e.response);
                this.$store.commit('setError', 'Something went wrong please make sure company number is correct')
                this.$store.commit('setLoading', false)
                return false
                
            }

        },
        handleGetCompanyFailure(data) {
            console.log("error data: ",data)
            let errMessage = !data ? 'Something went wrong' : data.errors.errors; 
            this.$store.commit('setError', errMessage)
            this.$store.commit('setLoading', false)
        },
     
        grayOutBackground(ids, revert = false) {
            if(Array.isArray(ids)){
                ids.forEach(id=>{
                    let field = document.getElementById(id); 
                    if(field) {
                        if(revert){
                            field.classList.remove("all-gray");

                        }else{
                            field.classList.add("all-gray");
                        }
                    
                    }
                })
            }
        },
        toggleComponent() {
            // if(!this.form || !this.checkAddressExists) {
            //     return;
            // }
            // console.log("visible: ", !this.form.contactInfo || !this.form.contactInfo.address || !this.form.contactInfo.postalCode || !this.form.contactInfo.state || !this.form.contactInfo.city)
            // let values = this.companyFields.map((el)=>{
            //    return this.getField(el)
            // })
            // if(values.includes(null) || values.includes('')) {
            //     this.visible = true;
            // }else {
                
                this.grayOutBackground(this.fieldsShouldGrayIds)
                // }
                this.allowCompanyReset = true
            // }
        }
    }, // End of Component > watch
} // End of export default
</script>
<style scoped>
.row {
    margin-left: 0;
}
.fetchBtn
{   margin-top: 27px !important;
    height: 36px !important;
    font-size: 12px !important;
}
.collapse-link{
    font-weight: bold !important;
    color: var(--primary-color) !important;
}
</style>